import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import store from '@/store'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  setDateRange({ commit }, data) {
    commit(types.SET_FILTER_DATERANGE, data)
  },
  setViewBy({ commit }, viewBy) {
    commit(types.SET_VIEW_BY, viewBy)
  },
  setTechnician({ commit }, technician) {
    commit(types.SET_TECHNICIAN, technician)
  },
  initCalibrate({ commit }, data) {
    commit(types.INIT_CALIBRATE, data)
  },
  initCalibrateEvent({ commit }, data) {
    commit(types.INIT_CALIBRATEEVENT, data)
  },
  updateCalibrate({ commit }, data) {
    commit(types.UPDATE_CALIBRATE, data)
  },
  setCalibrateStatus({ commit }, data) {
    commit(types.SET_CALIBRATESTATUS, data)
  },
  updateCalibrateEvent({ commit }, data) {
    commit(types.UPDATE_CALIBRATEEVENT, data)
  },
  updateCalibrateEventState({ commit }, data) {
    commit(types.UPDATE_CALIBRATEEVENT_STATE, data)
  },
  setCalibrateEventDialog({ commit }, is) {
    commit(types.SET_CALIBRATEEVENT_DIALOG, is)
  },
  setCalibrateCounts({ commit }, data) {
    console.log('Got Counts', data)
    if (data !== undefined && data !== null) {
      if (data.message !== undefined && data.message !== null) {
        commit(types.SET_CALIBRATECOUNTS, data.message)
      }
    }
  },
  setCalibrateChatCounts({ commit }, data) {
    commit(types.SET_CALIBRATE_CHATCOUNTS, data)
  },
  setServiceApproval({ commit }, data) {
    commit(types.SET_SERVICE_APPROVAL, data)
  },
  setRefreshRate({ commit }, data) {
    commit(types.SET_REFRESH_RATE, data)
  },
  setShowAll({ commit }, data) {
    commit(types.SET_SHOW_ALL, data)
  },
  clearPendingServiceIds({ commit }) {
    commit(types.CLEAR_PENDING_SERVICE_IDS)
  },
  resetCredit({ commit }) {
    commit(types.RESET_CREDIT)
  },
  setCredit({ commit }, data) {
    commit(types.SET_CREDIT, data)
  },
  async getCalibrateServiceRates({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getCalibrateServiceRates', () => http.get(`calibrate/calibrateServiceRates?firm=${firm}`))
    commit(types.SET_CALIBRATE_SERVICE_RATES, r.data)
    return r.data
  },
  async saveCalibrateServiceRates({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveCalibrateServiceRates', () => http.post('calibrate/saveCalibrateServiceRates', data))
    return r.data
  },
  async getCalibrates({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getCalibrates', () =>
      http.get('calibrate/calibrates', {
        params: searchOptions
      })
    )
    r.data.filter = searchOptions.filter
    commit(types.SET_CALIBRATES, r.data)
    return r.data
  },
  async getLocationCalibrates({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getLocationCalibrates', () =>
      http.get('calibrate/calibrates', {
        params: searchOptions
      })
    )
    r.data.filter = searchOptions.filter
    commit(types.SET_LOCATION_CALIBRATES, r.data)
    return r.data
  },
  async getMobileLocationCalibrates({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getLocationCalibrates', () =>
      http.get('calibrate/locationCalibrates', {
        params: searchOptions
      })
    )
    r.data.filter = searchOptions.filter
    commit(types.SET_LOCATION_CALIBRATES, r.data)
    return r.data
  },
  async filterByCenterPreference({ commit, dispatch, state }, data) {
    console.log('Filtering by Center Preference', state.locationCalibrates)
    let items = state.locationCalibrates.items
    let count = items.length
    let filteredItems = []
    let hideRequests = false
    // iterate through the existing list of location calibrate
    for (let i = 0; i < count; i++) {
      hideRequests = false
      let item = items[i]
      // get the calibrate events for the calibrate
      let calibrateEvents = await store.dispatch('calibrates/getCalibrateEvents', item.calibrate)
      if (calibrateEvents === undefined || calibrateEvents === null || calibrateEvents.length === 0) {
        hideRequests = true
      }
      for (let j = 0; j < calibrateEvents.length; j++) {
        let calibrateEvent = calibrateEvents[j]
        // break if the service firm is null (don't add this request to the list of filtered items)
        if (calibrateEvent.serviceFirm === null) {
          hideRequests = true
        } else {
          // get the preference for the service firm
          let preferences = await store.dispatch('locations/getPreference', {
            firm: calibrateEvent.serviceFirm,
            category: 'Center',
            name: 'HideRequestsOnMap'
          })
          if (Array.isArray(preferences)) {
            for (let k = 0; k < preferences.length; k++) {
              let preference = preferences[k]
              // break if the preference is set to hide requests on the map
              if (preference.name === 'HideRequestsOnMap' && preference.value === '1') {
                hideRequests = true
              }
            }
          } else {
            // treat the singular object the same as the objects within the array
            if (preferences.name === 'HideRequestsOnMap' && preferences.value === '1') {
              hideRequests = true
            }
          }
        }
      }
      // add the item to the list of filtered items
      if (!hideRequests) {
        filteredItems.push(item)
      }
    }
    let results = {
      items: filteredItems,
      count: filteredItems.length,
      filter: state.locationCalibrates.filter
    }
    commit(types.SET_LOCATION_CALIBRATES, results)
    console.log('Filtered Items', filteredItems)
  },
  async getCalibrate({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getCalibrate', () => http.get(`calibrate/calibrate?id=${id}`))
    commit(types.SET_CALIBRATE, r.data)
    return r.data
  },
  async saveCalibrate({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveCalibrate', () => http.post('calibrate/saveCalibrate', data))
    return r.data
  },
  async getCalibrateEvents({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getCalibrateEvents', () => http.get(`calibrate/calibrateEvents?calibrate=${id}`))
    commit(types.SET_CALIBRATEEVENTS, r.data)
    return r.data
  },
  async calibrateEventsActive({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'calibrateEventsActive', () =>
      http.get('calibrate/calibrateEventsActive', {
        params: options
      })
    )
    return r.data
  },
  async getCalibrateEvent({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getCalibrateEvent', () => http.get(`calibrate/calibrateEvent?id=${data.id}&username=${data.username}`))
    commit(types.SET_CALIBRATEEVENT, r.data)
    return r.data
  },
  async getCalibrateEventsAsRequests({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getCalibrateEventsAsRequests', () =>
      http.get('calibrate/calibrateEventsAsRequests', {
        params: searchOptions
      })
    )
    commit(types.SET_CALIBRATEREQUESTS, r.data)
    return r.data
  },
  async getOwnerCalibrates({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getOwnerCalibrates', () => http.get(`calibrate/ownerCalibrates?contact=${id}`))
    commit(types.SET_CALIBRATEEVENTS, r.data)
    return r.data
  },
  async saveCalibrateEvent({ commit, dispatch }, data) {
    console.log('Saving Calibrate Event', data)
    const r = await startLoading(dispatch, 'saveCalibrateEvent', () => http.post('calibrate/saveCalibrateEvent', data))
    let calibrateEventID = r.data
    // if the response is an object, then the calibrate event ID is in the object (first save of the calibrate event)
    if (typeof r.data === 'object') {
      calibrateEventID = r.data.calibrateEvent
    }
    commit(types.SET_CALIBRATEEVENTID, calibrateEventID)
    return calibrateEventID
  },
  async deleteCalibrateEvent({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteCalibrateEvent', () => http.post('calibrate/deleteCalibrateEvent', data))
    return r.data
  },
  async updateStatusCalibrate({ commit, dispatch }, data) {
    // DO NOT USE
    const r = await startLoading(dispatch, 'updateStatusCalibrate', () => http.post('calibrate/updateStatusCalibrate', data))
    commit(types.SET_CALIBRATESTATUS, data)
    return r.data
  },
  async sendReport({ commit, dispatch }, report) {
    const r = await startLoading(dispatch, 'sendReport', () =>
      http.get(`report/send${report.report}?calibrateEvent=${report.calibrateEvent}&NoDiscount=${report.noDiscount}`)
    )
    return r.data
  },
  async getRepairLines({ commit, dispatch }, calibrate) {
    const r = await startLoading(dispatch, 'getRepairLines', () => http.get(`calibrate/calibrateRepairLines?calibrate=${calibrate}`))
    commit(types.SET_REPAIRLINES, r.data)
    return r.data
  },
  async getCalibrateEventFileInfo({ commit, dispatch }, calibrateEvent) {
    const r = await startLoading(dispatch, 'getCalibrateEventFileInfo', () =>
      http.get(`calibrate/calibrateEventFileInfo?calibrateEvent=${calibrateEvent}`)
    )
    commit(types.SET_CALIBRATEEVENT_FILEINFO, r.data)
    return r.data
  },
  async calibrateCounts({ commit }, data) {
    const r = await http.get(`calibrate/calibrateCounts?firm=${data.firm}&type=${data.type}`)
    commit(types.SET_CALIBRATECOUNTS, r.data)
    return r.data
  },
  async updateStatusCalibrateEvent({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateStatusCalibrateEvent', () => http.post('calibrate/updateStatusCalibrateEvent', data))
    commit(types.SET_CALIBRATESTATUS, data)
    return r.data
  },
  async updateRequestStatus({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateRequestStatus', () => http.post('calibrate/updateRequestStatus', data))
    return r.data
  },
  async updateCalibrateEventActivity({ commit, dispatch }, activity) {
    const r = await startLoading(dispatch, 'updateCalibrateEventActivity', () => http.post('calibrate/updateCalibrateEventActivity', activity))
    commit(types.SET_CALIBRATEEVENT_ACTIVITY, activity)
    return r.data
  },
  async saveCalibrateEventSchedule({ commit, dispatch }, scheduled) {
    const r = await startLoading(dispatch, 'saveCalibrateEventSchedule', () => http.post('calibrate/saveCalibrateEventSchedule', scheduled))
    return r.data
  },
  async sendForAuthorization({ commit }, calibrateEvent) {
    const r = await http.get(`admin/sendForAuthorization?calibrateEvent=${calibrateEvent}`)
    return r.data
  },
  async getCalibrateServicesForAuthorization({ commit, dispatch }, calibrateEvent) {
    const r = await startLoading(dispatch, 'getCalibrateServicesForAuthorization', () =>
      http.get(`calibrate/getCalibrateServicesForAuthorization?calibrateEvent=${calibrateEvent}`)
    )
    commit(types.SET_REQUEST_SERVICES, r.data)
    return r.data
  },
  async updateServiceAuthorization({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateServiceAuthorization', () => http.post('calibrate/updateServiceAuthorization', data))
    return r.data
  },
  async sendForAuthorizationService({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'sendForAuthorizationService', () => http.get(`admin/sendForAuthorizationService?CalibrateEvent=${id}`))
    return r.data
  },
  async updatePaymentCalibrateEvent({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updatePaymentCalibrateEvent', () => http.post('calibrate/updatePaymentCalibrateEvent', data))
    return r.data
  },
  async updateCalibrateServiceItem({ commit, dispatch }, data) {
    if (data.calibrateEvent) {
      const r = await startLoading(dispatch, 'updateCalibrateServiceItem', () => http.post('calibrate/updateCalibrateServiceItem', data))
      commit(types.UPDATE_REQUEST_SERVICES, r.data)
      return r.data
    } else {
      commit(types.UPDATE_PENDING_SERVICE_IDS, data)
      return data
    }
  },
  async getInvoicePreferences({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getInvoicePreferences', () => http.get(`calibrate/invoicePreferences?calibrateEvent=${id}`))
    commit(types.SET_INVOICE_PREFERENCES, r.data)
    return r.data
  },
  async getScansByVIN({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'getScansByVIN', () => http.get(`calibrate/scansByVIN?vin=${vin}`))
    commit(types.SET_SCANS, r.data)
    return r.data
  },
  async getScreenShotsByVIN({ commit, dispatch }, data) {
    // firm/bucketContents?firm=1&path=1GYKNARS4JZ241801&bucket=blue-ocean-expert-mode
    const r = await startLoading(dispatch, 'getScreenShotsByVIN', () =>
      http.get(`firm/bucketContents?firm=${data.firm}&path=${data.path}&bucket=${data.bucket}`)
    )
    commit(types.ADD_TO_SCANS, r.data)
  },
  async getScan({ commit, dispatch }, url) {
    console.log('Getting Scan File URL:', url)
    let response = await http.get(url)
    return response
  },
  async creditCalibrateEvent({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveCredit', () => http.post('calibrate/SaveCalibrateEventCredit', data))
    return r.data
  },
  async cancelCalibrateEventCredit({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'cancelCalibrateEventCredit', () => http.get(`calibrate/cancelCalibrateEventCredit?calibrateEvent=${id}`))
    return r.data
  },
  async setPendingStatusChange({ commit }, data) {
    commit(types.SET_PENDING_STATUS_CHANGE_OBJECT, data)
  },
  async removeServicesFromCalibrate({ commit, dispatch, state }, data) {
    let eventsArray = state.calibrate.lastEvent
    if (eventsArray !== undefined && eventsArray !== null) {
      eventsArray.forEach(async element => {
        await store.dispatch('calibrates/getCalibrateEvent', { id: element.calibrateEvent, username: null })
        // Only removing services from open requests
        if (state.calibrateEvent.calibrateEventStatusType !== 4 && state.calibrateEvent.calibrateEventStatusType !== 5) {
          store.dispatch('calibrates/removeServicesFromCalibrateEvent', data)
        }
      })
    }
  },
  async removeServicesFromCalibrateEvent({ commit, dispatch, state, rootState }, data) {
    // for each item in serviceList, run updateCalibrateServiceItem to remove it
    const contact = rootState.auth.profile.contact
    state.calibrateEvent.serviceList.forEach(async item => {
      let resultId = null
      if (item.calibrateServiceResult >= 0) {
        if (item.calibrateServiceResult !== item.id) {
          resultId = parseInt(item.calibrateServiceResult)
        }
      }
      await store.dispatch('calibrates/updateCalibrateServiceItem', {
        firm: parseInt(state.calibrateEvent.firm),
        calibrateServiceResult: resultId,
        calibrateEvent: parseInt(state.calibrateEvent.calibrateEvent),
        calibrateService: parseInt(item.id),
        createdBy: parseInt(contact),
        description: item.description ? item.description : item.name,
        amount: item.amount ? parseFloat(item.amount) : item.rate ? parseFloat(item.rate) : null,
        checked: false
      })
      console.log('Removing Service', item)
    })
  },
  async getPricingRuleResults({ commit, dispatch }, calibrateEvent) {
    const r = await startLoading(dispatch, 'getPricingRuleResults', () => http.get(`calibrate/pricingRuleResult?calibrateEvent=${calibrateEvent}`))
    commit(types.SET_PRICINGRULERESULTS, r.data)
    return r.data
  },
  async servicesPushToCCC({ commit, dispatch }, calibrateEvent) {
    const r = await startLoading(dispatch, 'pushToCCC', () => http.get(`calibrate/pushToCCC?calibrateEvent=${calibrateEvent}`))
    return r.data
  },
  async searchForRequest({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'searchForRequest', () => http.get(`calibrate/searchCalibrateForVin?vin=${data.vin}&adasInspection=${data.adasInspection}`))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/calibrates/actions.js